import styled, { css } from 'styled-components';
import { getSafeAreaValue } from '../../styled/theme/helpers/getSafeAreaValue';

interface TabBarLinkProps {
  centered?: boolean;
  $active?: boolean;
}

export const TabBarContainer = styled.div<{ $isHidden?: boolean }>`
  position: relative;

  @media screen and (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    display: none;
  }

  ${({ $isHidden }) =>
    $isHidden &&
    css`
      visibility: hidden;
    `}
`;

export const TabBarWrapper = styled.div`
  position: fixed;
  min-height: ${({ theme }) => `${theme.mobile.tabBar.height}px`};
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px 15px ${({ theme }) => getSafeAreaValue(theme, 'bottom', 4)};
  border-top: 1px solid ${({ theme: { colors } }) => colors.border.primary};
  background: ${({ theme: { colors } }) => colors.background.primary};
  z-index: 99;
  transition: transform 0.2s linear;
`;

export const TabBarList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  align-items: center;
  justify-content: space-around;
  gap: 11px;
`;

export const TabBarListItem = styled.li`
  position: relative;
  width: 20%;
  max-width: 60px;
  text-align: center;
`;

export const TabBarLink = styled.div<TabBarLinkProps>`
  height: 35px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  text-decoration: none;
  width: 100%;
  white-space: nowrap;
  cursor: pointer;

  ${({ centered }) =>
    centered &&
    css`
      position: absolute;
      padding: 0;
      height: auto;
      gap: 5px;
      left: 50%;
      top: -41px;
      transform: translate(-50%);
    `}

  svg {
    fill: ${({ $active, theme: { colors } }) =>
      colors.text[$active ? 'primary' : 'secondary']};
  }
`;

export const TabBarIconWrapper = styled.i`
  align-self: center;
`;

export const TabBarLinkText = styled.span<{ $active?: boolean }>`
  font-family: Helvetica, Arial, sans-serif;
  color: ${({ $active, theme: { colors } }) =>
    colors.text[$active ? 'primary' : 'secondary']};
  text-align: center;
  font-size: 8px;
  text-transform: uppercase;
`;

export const HiddenBar = styled.div`
  transform: translateY(145%);
`;
